import '@/utils/rem.js'
// import axios from "axios"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import Pagination from 'vue-pagination-2'
import App from './App.vue'
import api from './api/'
import './plugins/element.js'
import router from './router'
import store from './store'
// eslint-disable-next-line vue/multi-word-component-names
// Vue.component('pagination', Pagination);
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

// axios.defaults.baseURL = 'http://192.168.110.59:8866';
Vue.use(ElementUI, Pagination);
Vue.config.productionTip = false
Vue.prototype.$api = api;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
